import { useMemo } from "react";
import { useTheme } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import { BottomNavItem } from "./BottomNavItem";
import { HomeSvg } from "./HomeSvg";

export const HomeNavItem = () => {
  const theme = useTheme();

  const navigate = useNavigate();

  const { pathname } = useLocation();

  const isActive = useMemo(() => {
    return pathname === "/home";
  }, [pathname]);

  const onClick = () => {
    navigate("/home");
  };

  return (
    <BottomNavItem
      icon={<HomeSvg style={{ fontSize: 22, color: isActive ? theme.palette.primary.main : "white" }} />}
      label="Home"
      onClick={onClick}
    />
  );
};
